/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{bottom:0;box-sizing:border-box;display:flex;min-height:100vh;flex-flow:column;left:0;margin:0;padding:0;right:0;top:0}router-outlet[_ngcontent-%COMP%]{display:none;flex:none}router-outlet[_ngcontent-%COMP%] +   *{flex:1 0 auto}"];
export { styles as styles };
